<template>
  <v-layout
    row
    wrap
    class="pa-4"
  >
    <v-flex xs12>
      <Toggle
        v-model="photo.visitor_photo"
        class="visitorPhotoTB"
        title="Visitor Photo"
        caption="If enabled new visitors should take their photos"
        @change="updatePhotoToggle"
      />
      <Toggle
        v-model="photo.returning_visitor_photo"
        title="Returning Visitor Photo"
        caption="If enabled returning visitors should take photos again, which enhances security"
        @change="updateReturningPhotoToggle"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import _cloneDeep from 'lodash/cloneDeep';
import Toggle from '@/components/common/Toggle';

export default {
  name: 'Photo',
  components: {
    Toggle
  },
  props: {
    data: {
      type: Object,
      default: null,
      required: true
    }
  },
  data() {
    return {
      photo: {}
    };
  },
  watch: {
    data: {
      handler(val) {
        if (!val) return;
        this.photo = _cloneDeep(val);
      },
      immediate: true
    }
  },
  deactivated() {
    const validation = true;
    this.$emit('update', [this.photo, validation]);
  },
  methods: {
    updatePhotoToggle(val) {
      this.photo.visitor_photo = val;
    },
    updateReturningPhotoToggle(val) {
      this.photo.returning_visitor_photo = val;
    }
  }
};
</script>

